module.exports = __webpack_public_path__ + "static/media/dulce-logo.200e849d.png";